export const moduleName = 'signUp'
